import { Component, Injector } from '@angular/core';
import { DialogBaseComponent } from "../../../admin-panel/base-admin-panel/dialog-base/dialog-base.component";

@Component({
    selector: 'app-photo-gallery-dialog',
    templateUrl: './photo-gallery-dialog.component.html',
    styleUrls: ['./photo-gallery-dialog.component.css'],
    standalone: false
})
export class PhotoGalleryDialogComponent extends DialogBaseComponent<any> {

  constructor(protected injector: Injector) {
    super(injector);
  }
 
}
